import { FinalEvaluation } from "./projectService";
import FileSaver, { saveAs } from "file-saver";
import createReport from "docx-templates";
import { fetchAuthSession } from 'aws-amplify/auth';
import { getUrl } from 'aws-amplify/storage';
import { postJson } from "./httpClient";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

interface RadarDataset {
  label: string;
  backgroundColor: string;
  borderColor: string;
  pointBackgroundColor: string;
  poingBorderColor: string;  // Posible error, debería ser `pointBorderColor`
  pointHoverBackgroundColor: string;
  pointHoverBorderColor: string;
  data: number[];
};

async function loadDocxTemplate(): Promise<ArrayBuffer> {
  //const url = await getUrl({
  //  path:'/InformeRL.docx'
  //});
  //const response = await fetch(url.url); // Asegúrate de colocar el archivo en `public/`
  const response = await fetch('/InformeRL.docx'); // Asegúrate de colocar el archivo en `public/`
  if (!response.ok) {
    throw new Error("No se pudo cargar la plantilla DOCX");
  }

  return response.arrayBuffer(); // Convertir a binario
}

async function loadImageAsBase64(url: string): Promise<string> {
  const response = await fetch(url);
  const blob = await response.blob();
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      const base64String = reader.result as string;
      const base64WithoutPrefix = base64String.split(",")[1]; // Quita "data:image/png;base64,"
      resolve(base64WithoutPrefix);
    };
    reader.readAsDataURL(blob); // Convertir imagen a Base64
  });
}

export function getRadarData(p: FinalEvaluation) {
  let datasets: RadarDataset[] = [];
  let retorno = {
    labels: ["BRL", "IPRL", "FRL", "TmRL", "TRL"],
    datasets: datasets
  };
  const largo = p.evaluacion.length;
  const divisor = largo - 1;
  var salto = divisor === 0 ? 1 : (255 / divisor);
  salto = Math.trunc(salto);
  var cuenta = 1;
  var acumulado = 0;
  console.log("Evaluacion para imagen:"+JSON.stringify(p.evaluacion));
  for (let i = 0; i < p.evaluacion.length; i++) {
    var g = acumulado;
    if (largo === cuenta) {
      g = 255;
    }
    acumulado = acumulado + salto;
    cuenta++;
    retorno.datasets.push({
      label: "Evaluación " + new Date(p.evaluacion[i].fechaEvaluacion ?? new Date()).toLocaleDateString("es-CL", { day: "2-digit", month: "2-digit", year: "numeric" }),
      backgroundColor: "rgba(" + g + ", 202, 0, 0)",
      borderColor: "rgba(" + g + ", 202, 0, 1)",
      pointBackgroundColor: "rgba(" + g + ", 202, 0, 1)",
      poingBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(" + g + ", 202, 0, 1)",
      data: [p.evaluacion[i].brl.level, p.evaluacion[i].iprl.level, p.evaluacion[i].frl.level, p.evaluacion[i].tmrl.level, p.evaluacion[i].trl.level]
    })
  }
  console.log("evaluacion para imagen:"+JSON.stringify(retorno));
  return retorno;
}

export async function enviarWordDocument(idProyecto: Number, base64ImageInput: string) {
  try {
    const sesion = await fetchAuthSession();
    const token = sesion.tokens?.idToken;
    const data = await postJson<SendEvaluationResponse>(`${API_BASE_URL}/project/send-evaluation`, {
      idProject: idProyecto,
      base64Image: base64ImageInput
    }, {
      "Authorization": `Bearer ${token}`,
    });
    //console.log(base64ImageInput);

    //console.log("response:"+JSON.stringify(resp));
    if (data.status)
      return data.status;
    throw new Error("No se envió evaluacion");
  } catch (error) {
    console.error("Error al obtener evaluacion de proyecto:", error);
    //throw error;
  }

}

export async function descargarPdf(idProject: number) {
  try {
    const idProyecto = idProject;
    const apiGatewayUrl = `${API_BASE_URL}/project/get-pdf`;
    const sesion = await fetchAuthSession();
    const token = sesion.tokens?.idToken;
    const response = await fetch(`${apiGatewayUrl}?idProyecto=${idProyecto}`, {
      method: "GET",
      headers: {
        "Authorization": `Bearer ${token}`, // Si necesitas autenticación
      }
    });

    if (!response.ok) {
      throw new Error("No se pudo descargar el documento.");
    }

    const blob = await response.blob();
    //console.log("resp:"+response);
    //console.log("blob json:"+blob.type);
    //console.log(await blob.text());
    //console.log(blob);
    //console.log(await blob.slice(0,30).text());
    return blob;
  } catch (error) {
    console.error("Error al descargar el PDF:", error);
  }
}

export async function generateWordDocument(eva: FinalEvaluation, base64ImageInput: string) {

  const data = eva;

  const template = await loadDocxTemplate();

  const base64Image = base64ImageInput.replace('data:image/png;base64,', '');
  const nombre_proyecto = data.nombre;
  const buffer = await createReport({
    template: new Uint8Array(template),
    data: {
      nombre_proyecto,
      brl: data.evaluacion[0].brl.questionText,
      brl0: data.evaluacion[0].brl.level,
      brl0n: data.evaluacion[0].brl.rl0n,
      brl0na: data.evaluacion[0].brl.rl0na,
      brl0nb: data.evaluacion[0].brl.rl0nb,
      brl0nc: data.evaluacion[0].brl.rl0nc,
      brl0nd: data.evaluacion[0].brl.rl0nd,
      trl: data.evaluacion[0].trl.questionText,
      trl0: data.evaluacion[0].trl.level,
      trl0n: data.evaluacion[0].trl.rl0n,
      trl0na: data.evaluacion[0].trl.rl0na,
      trl0nb: data.evaluacion[0].trl.rl0nb,
      trl0nc: data.evaluacion[0].trl.rl0nc,
      trl0nd: data.evaluacion[0].trl.rl0nd,
      iprl: data.evaluacion[0].iprl.questionText,
      iprl0: data.evaluacion[0].iprl.level,
      iprl0n: data.evaluacion[0].iprl.rl0n,
      iprl0na: data.evaluacion[0].iprl.rl0na,
      iprl0nb: data.evaluacion[0].iprl.rl0nb,
      iprl0nc: data.evaluacion[0].iprl.rl0nc,
      iprl0nd: data.evaluacion[0].iprl.rl0nd,
      tmrl: data.evaluacion[0].tmrl.questionText,
      tmrl0: data.evaluacion[0].tmrl.level,
      tmrl0n: data.evaluacion[0].tmrl.rl0n,
      tmrl0na: data.evaluacion[0].tmrl.rl0na,
      tmrl0nb: data.evaluacion[0].tmrl.rl0nb,
      tmrl0nc: data.evaluacion[0].tmrl.rl0nc,
      tmrl0nd: data.evaluacion[0].tmrl.rl0nd,
      frl: data.evaluacion[0].frl.questionText,
      frl0: data.evaluacion[0].frl.level,
      frl0n: data.evaluacion[0].frl.rl0n,
      frl0na: data.evaluacion[0].frl.rl0na,
      frl0nb: data.evaluacion[0].frl.rl0nb,
      frl0nc: data.evaluacion[0].frl.rl0nc,
      frl0nd: data.evaluacion[0].frl.rl0nd,
      grafico: base64Image,
    },
    additionalJsContext: {
      // Configuración especial para imágenes en docx-templates
      image_module: async (img: any) => {
        console.log("cargando la imagen");
        if (!img) throw new Error("Imagen no válida o no encontrada.");
        return {
          width: 15, // Ancho en cm
          height: 10, // Alto en cm
          data: img, // Base64 de la imagen
          extension: ".png", // Formato de imagen
        }
      },
    },
  });

  // Crear un Blob y descargar el archivo
  const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document" });
  //console.log("documento---->"+blob);
  FileSaver.saveAs(blob, "InformeRL.docx");

}


export const RadarOptions = {
  responsive: true, // Permite la respuesta al tamaño del contenedor
  maintainAspectRatio: false, // Deshabilita la relación de aspecto automática
  scales: {
    r: {  // Usar 'r' en Chart.js v3+
      ticks: {
        beginAtZero: true, // Asegura que la escala comience en 0
        min: 0,  // Valor mínimo de la escala
        max: 9,  // Valor máximo de la escala
        stepSize: 1, // Paso entre valores
        showLabelBackdrop: false,
        backdropColor: "rgba(203, 197, 11, 1)"
      },
      pointLabels: {
        //color: "#333",      // Color del texto
      },
      angleLines: {
        color: "rgba(0, 0, 0, .3)",
        display: true,
        lineWidth: 1
      },
      grid: {
        color: "rgba(0, 0, 0, .3)",
        circular: true
      },
      suggestedMin: 0, // Sugerencia para la escala mínima
      suggestedMax: 9  // Sugerencia para la escala máxima
    }
  },
  elements: {
    line: {
      borderWidth: 1
    },
    point: {
      radius: 3
    }
  },
  plugins: {
    legend: {
      position: 'right',
    }
  }
};

export interface SendEvaluationResponse {
  message: string;
  error?: string;
  status?: boolean;
}
